import axios from "axios";
import TokenService from "../services/storage";
import store from "../store";
import router from "../router";

const endpoint = process.env.VUE_APP_API_ENDPOINT;

export const instance = axios.create({
  baseURL: endpoint,
  timeout: 30000
});

// Add Authorization header for each request
instance.interceptors.request.use(
  function(config) {
    config.headers.Authorization = `Bearer ${TokenService.getToken()}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Logout if we have a 401 error
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // Status 401, logout
      if (error.response.status === 401) {
        store
          .dispatch("auth/logout")
          .then(() => {
            router.push({ name: "LoginPage" });
          })
          .catch(() => {
            router.push({ name: "LoginPage" });
          });
      }
    }

    throw error;
  }
);

// const handleError = error => {
//   const errorStatus = error.response ? error.response.status : error;
//   const errorMessage = prepareErrorMessages(errorStatus);

//   console.log(errorStatus, errorMessage);

//   throw error;
// };

// const prepareErrorMessages = status => {
//   switch (status) {
//     case 401:
//       return "Nope, go away";
//     case 422:
//       return "Unprosomething entity";
//     case 404:
//       return "You're lost";
//     case 405:
//       return "Read the manual";
//     default:
//       return "Error, please try again later";
//   }
// };

export default instance;
